import { render, staticRenderFns } from "./MyCreatedHelp.vue?vue&type=template&id=62d6ec21&scoped=true&"
import script from "./MyCreatedHelp.vue?vue&type=script&lang=js&"
export * from "./MyCreatedHelp.vue?vue&type=script&lang=js&"
import style0 from "./MyCreatedHelp.vue?vue&type=style&index=0&id=62d6ec21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d6ec21",
  null
  
)

export default component.exports